import React from 'react';
import { ResetPasswordStep as ResetPasswordStepCore } from '@fiverr-private/identification_core';
import { useStepsContext } from '../StepsContext';

export const ResetPasswordStep = () => {
    const { goBack, hasBack } = useStepsContext();
    return <ResetPasswordStepCore goBack={hasBack ? goBack : undefined} />;
};
